import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFlag1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFlag1"><Path d="M4.5 21.5V15.5M4.5 15.5V2.5H20.5L16.5 9L20.5 15.5H4.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFlag1;
